import { OBJETIVOS_SEM_PARAMETROS } from '../constants';
import type { CampoParametroSelf, ObjetivoSelf, ValoresParametros } from '../types';

export const objetivoPulaParametros = (objetivo: ObjetivoSelf | null): boolean =>
  Boolean(objetivo && OBJETIVOS_SEM_PARAMETROS.includes(objetivo));

export const mascararValorCampo = (campo: CampoParametroSelf, valor: string): string => {
  if (campo.tipo === 'NUMBER') {
    return valor.replace(/\D/g, '');
  }
  if (campo.tipo === 'FINANCEIRO') {
    return valor.replace(/[^\d.,]/g, '');
  }
  return valor;
};

export const campoPreenchido = (
  campo: CampoParametroSelf,
  valor: string | boolean | undefined,
): boolean => {
  if (campo.tipo === 'BOOLEAN') {
    return typeof valor === 'boolean';
  }
  return typeof valor === 'string' && valor.trim().length > 0;
};

const FINANCEIRO_SEM_AGRUPAMENTO = /^\d{1,12}(,\d{2})?$/;
const FINANCEIRO_COM_AGRUPAMENTO = /^\d{1,3}(\.\d{3})+(,\d{2})?$/;

const financeiroValido = (valor: string): boolean =>
  FINANCEIRO_SEM_AGRUPAMENTO.test(valor) || FINANCEIRO_COM_AGRUPAMENTO.test(valor);

export const campoValido = (
  campo: CampoParametroSelf,
  valor: string | boolean | undefined,
): boolean => {
  if (!campo.obrigatorio && !campoPreenchido(campo, valor)) return true;
  if (!campoPreenchido(campo, valor)) return false;
  if (campo.tipo === 'FINANCEIRO' && typeof valor === 'string') {
    return financeiroValido(valor.trim());
  }
  return true;
};

export const podeAvancarParametros = (
  campos: CampoParametroSelf[],
  valores: ValoresParametros,
): boolean => campos.every((campo) => campoValido(campo, valores[campo.key]));

export const formatarValorParametro = (
  campo: CampoParametroSelf,
  valor: string | boolean | undefined,
): string => {
  if (campo.tipo === 'BOOLEAN') {
    if (valor === true) return 'Sim';
    if (valor === false) return 'Não';
    return '—';
  }
  if (typeof valor !== 'string' || !valor.trim()) return '—';
  return [campo.prefixo, valor.trim(), campo.sufixo].filter(Boolean).join(' ');
};
